export const STYLE: google.maps.MapTypeStyle[] = [
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
      {
        saturation: -100
      }
    ]
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [
      {
        saturation: -100
      },
      {
        visibility: "on"
      }
    ]
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [
      {
        saturation: -75
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#dddddd"
      },
      {
        saturation: -100
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#dddddd"
      },
      {
        saturation: -100
      }
    ]
  }
];